// @flow

import Model from "app/models/Model";

export const types = {
    SUCCESS: "success",
    WARNING: "warning",
    ERROR: "error"
};

export default class Notification extends Model {
    static key = 1;
    key: number;

    type: string;
    message: string;

    constructor() {
        super();
        this.key = Notification.key++;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/Notification.js